import { render, staticRenderFns } from "./ImportDocuments.vue?vue&type=template&id=bb14bb18&scoped=true"
import script from "./ImportDocuments.vue?vue&type=script&lang=js"
export * from "./ImportDocuments.vue?vue&type=script&lang=js"
import style0 from "./ImportDocuments.vue?vue&type=style&index=0&id=bb14bb18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb14bb18",
  null
  
)

export default component.exports